export default __webpack_public_path__ + "static/media/thum2.8f781b09.jpg";